const VISITOR_STORAGE_KEY = 'koho_first_visited';
let _isNewVisitorCached: boolean | null = null;

export const initVisitorTracking = (): void => {
  if (typeof window === 'undefined' || _isNewVisitorCached !== null) return;

  const storedDate = localStorage.getItem(VISITOR_STORAGE_KEY);
  if (storedDate === null) {
    localStorage.setItem(VISITOR_STORAGE_KEY, new Date().toISOString().split('T')[0]);
  }
};

export const isNewVisitor = (): boolean => {
  if (_isNewVisitorCached !== null) return _isNewVisitorCached;
  if (typeof window === 'undefined') return true; // SSR default

  const today = new Date().toISOString().split('T')[0];
  const storedDate = localStorage.getItem(VISITOR_STORAGE_KEY);

  _isNewVisitorCached = storedDate === null || storedDate === today;

  return _isNewVisitorCached;
};
